import React, { Component } from 'react';
import "react-toggle/style.css";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import EditIcon from '@material-ui/icons/Edit';
import MoreIcon from '@material-ui/icons/MoreHoriz';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import Switch from '@material-ui/core/Switch';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
/* Routes */
import { S } from '../../../routes/routes'
/* Sagas Action */
import { actions as notificationActions } from '../../../redux/ducks/notification'
import { safeDeepGetWithType, safeDeepGet } from 'iotera-base/json';
import { isInteger, isFunction } from 'iotera-base/object';
import { getWidthColumnByPercent } from '../../../lib/components/function';
import { TablePaginationActionsWrapped, CustomTableCell } from '..';
/* React Confirm Alert */
import { ioteraConfirmAlert } from '../../../lib/components/react/react-confirm-alert';

class RulesTable extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.goTo = this.goTo.bind(this);
    this.state = {
      tooltipOpen: false,
      page: 0,
      rowsPerPage: 10,
      dropdownOpen: {}
    };
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.handleChangeStatusToggle = this.handleChangeStatusToggle.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleEdit = (ruleId) => event => {
    ioteraConfirmAlert(
      'Konfirmasi',
      'Ubah manual atau dengan editor?',
      'Editor',
      'disable',
      'Manual',
      () => {
        this.props.history.push('.' + S + '_rule_edit_' + S + ruleId)
      }
    );
  }

  handleDelete = (ruleId) => event => {
    let handleDelete = safeDeepGetWithType(this, ['props', 'handleDelete']);
    if (isFunction(handleDelete)) {
      ioteraConfirmAlert(
        'Konfirmasi Hapus Rule',
        'Apakah anda yakin ingin menghapus rule ini?',
        null,
        () => handleDelete(ruleId),
        null,
        null
      )
    }
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    let rowsPerPage = event.target.value;
    if (!isInteger(rowsPerPage))
      rowsPerPage = parseInt(rowsPerPage)
    this.setState({ page: 0, rowsPerPage });
  };

  toggle() {
    const _this = this
    const _state = _this.state
    const { tooltipOpen } = _state
    this.setState({
      tooltipOpen: !tooltipOpen
    });
  }

  onMouseEnter(key) {
    const _this = this
    const _state = _this.state
    let dropdownOpen = Object.assign({}, _state.dropdownOpen);
    // set dropdown visible 
    dropdownOpen[key] = true;
    _this.setState({ dropdownOpen });
  }

  onMouseLeave(key) {
    const _this = this
    const _state = _this.state
    let dropdownOpen = Object.assign({}, _state.dropdownOpen);
    // set dropdown hidden 
    dropdownOpen[key] = false;
    _this.setState({ dropdownOpen });
  }

  handleAllCheck = event => {
    this.props.onCheckedRule(event.target.checked)
  }

  handleChangeStatusToggle = (id, value) => {
    const word = value ? 'me-non-aktifkan' : 'mengaktifkan'
    const handleChangeStatus = safeDeepGet(this, ['props', 'handleChangeStatus']);
    if (isFunction(handleChangeStatus)) {
      ioteraConfirmAlert(
        null,
        'Apakah anda yakin ingin ' + word + ' rule ini?',
        null,
        () => handleChangeStatus(id, !value),
        null,
        null
      )
    }
  }

  goTo(link) {
    this.props.history.push(link)
  }

  render() {
    const _this = this
    const _state = _this.state
    const _props = _this.props
    let data = safeDeepGet(_props, ['data']);
    let tableWidth = safeDeepGetWithType(_props, ['tableSize', 'width'], 0);
    const { rowsPerPage, page } = _state;
    let ruleRows = []
    Object.keys(data).forEach((key, index) => {
      let currData = data[key];
      // get dropdown is open or not
      let dropdownIsOpen = safeDeepGetWithType(_state, ['dropdownOpen', index], false);
      let id = safeDeepGetWithType(currData, ['id'], '');
      let name = safeDeepGetWithType(currData, ['name'], '');
      let description = safeDeepGetWithType(currData, ['description'], '-');
      let active = safeDeepGetWithType(currData, ['active'], false);
      const colorOn = active === true ? '#4D2C91' : '#B2B2B266';
      const colorOff = active === false ? '#000' : '#B2B2B266';
      const visible = tableWidth > 576 ? 'visible' : 'collapse';
      ruleRows.push(
        <TableRow key={index} className='table-row-child-iotera'>
          <TableCell component="th" scope="row" column='rule' style={{ textAlign: 'left' }}>
            <span><b className='text-capitalize'>{name}</b></span>
          </TableCell>
          <TableCell column='description' style={{ textAlign: 'left' }}>
            <span><i>{description}</i></span>
          </TableCell>
          <TableCell column='active' style={{ textAlign: 'center' }}>
            <span>
              <i style={{ color: colorOff, visibility: visible }}>OFF</i>
              <Switch checked={active} color="primary" onChange={() => _this.handleChangeStatusToggle(id, active)} />
              <i style={{ color: colorOn, visibility: visible }}>ON</i>
            </span>
          </TableCell>
          <TableCell column='settings' style={{ textAlign: 'center' }}>
            <UncontrolledDropdown onMouseOver={(e) => _this.onMouseEnter(index)}
              onMouseLeave={(e) => _this.onMouseLeave(index)} isOpen={dropdownIsOpen} style={{ cursor: 'pointer' }}>
              <DropdownToggle tag="div">
                <MoreIcon color="inherit" style={{ height: 30, width: 30 }} />
              </DropdownToggle>
              <DropdownMenu style={{ padding: 0, margin: 0 }}>
                <DropdownItem style={{ margin: 0 }} onClick={_this.handleEdit(currData.id)}>
                  <EditIcon color="inherit" style={{ height: 18, width: 18 }} />&emsp;<span style={{ marginRight: 20 }}>Edit</span>
                </DropdownItem>
                <DropdownItem style={{ margin: 0 }} onClick={_this.handleDelete(id)}>
                  <DeleteIcon color="inherit" style={{ height: 18, width: 18 }} />&emsp;<span style={{ marginRight: 20 }}>Hapus</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </TableCell>
        </TableRow >
      )
    })
    return (
      <Table className="table"
      >
        <TableHead style={{ height: 0 }}>
          <TableRow>
            <CustomTableCell column='rule' style={{
              textAlign: 'left', minWidth: getWidthColumnByPercent(25, tableWidth),
              maxWidth: getWidthColumnByPercent(25, tableWidth)
            }}><span>Rule</span></CustomTableCell >
            <CustomTableCell column='description' style={{
              textAlign: 'left', minWidth: getWidthColumnByPercent(40, tableWidth),
              maxWidth: getWidthColumnByPercent(40, tableWidth)
            }}><span>Deskripsi</span></CustomTableCell >
            <CustomTableCell column='active' style={{
              textAlign: 'center', minWidth: getWidthColumnByPercent(25, tableWidth),
              maxWidth: getWidthColumnByPercent(25, tableWidth)
            }}><span>Status</span></CustomTableCell >
            <CustomTableCell column='settings' style={{
              textAlign: 'center', minWidth: getWidthColumnByPercent(10, tableWidth),
              maxWidth: getWidthColumnByPercent(10, tableWidth)
            }}><span>Aksi</span></CustomTableCell >
          </TableRow>
        </TableHead>
        <TableBody>
          {ruleRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} dari ${count}`}
              labelRowsPerPage='Baris terlihat:'
              rowsPerPageOptions={[5, 10, 25]}
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                native: true,
              }}
              onPageChange={_this.handleChangePage}
              onChangeRowsPerPage={_this.handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActionsWrapped}
            />
          </TableRow>
        </TableFooter>
      </Table>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(notificationActions, dispatch)
});

export default connect(null, mapDispatchToProps)(RulesTable);